import { useGetCities } from '@entities/region';
import { Loader, Text } from '@mantine/core';
import { FormMultiselect } from '@shared/ui';
import { IconChevronDown } from '@tabler/icons-react';
import { useState } from 'react';

export type CandidateCityValue = {
  allCities: boolean;
  cityIds: number[];
};

export const normalizeCandidateCityValue = ({
  allCities,
  cityIds,
}: CandidateCityValue): CandidateCityValue => {
  const shouldUseAllCities = allCities || cityIds.length === 0;

  return {
    allCities: shouldUseAllCities,
    cityIds: shouldUseAllCities ? [] : cityIds,
  };
};

type CandidateCitySelectProps = CandidateCityValue &
  (
    | {
        mode: 'card';
      }
    | {
        mode: 'edit';
        onChange: (value: CandidateCityValue) => void;
      }
  );

export const CandidateCitySelect = (props: CandidateCitySelectProps) => {
  const value = normalizeCandidateCityValue(props);
  const [shouldLoadCities, setShouldLoadCities] = useState(!value.allCities);
  const { data: cities, isLoading } = useGetCities(
    shouldLoadCities || !value.allCities
  );

  if (props.mode === 'card') {
    const cityNames = value.allCities
      ? 'Все города'
      : cities
          ?.filter(city => value.cityIds.includes(city.id))
          .map(city => city.name)
          .join(', ') || '-';

    return <Text c='primary.7'>{cityNames}</Text>;
  }

  const selectedCityIds = value.allCities
    ? []
    : value.cityIds.map(cityId => cityId.toString());

  const handleChange = (cityIds: string[]) => {
    props.onChange({
      allCities: cityIds.length === 0,
      cityIds: cityIds.map(Number),
    });
  };

  return (
    <FormMultiselect
      title='Город'
      description='Города поиска работы'
      placeholder={value.allCities ? 'Все города' : 'Выберите города'}
      value={selectedCityIds}
      data={cities?.map(city => ({
        label: city.name,
        value: city.id.toString(),
      }))}
      onChange={handleChange}
      onDropdownOpen={() => setShouldLoadCities(true)}
      rightSection={
        isLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      containerProps={{ pt: 0 }}
      searchable
      clearable
    />
  );
};
